export default "__VITE_ASSET__740c037f__"